import * as yup from 'yup';

import { FleetBase, fleetSchema } from '../domain/fleet';
import { personalInfoSchema } from '../domain/person';
import { isSmallBusiness } from '../domain/qualification';
import {
  businessPageOneKeys,
  businessPageTwoKeys,
  businessPageVerifyKeys,
  selectBusinessInfo,
  spendIntentKeys,
  spendIntentKeysV2,
} from '../features/application/reducers/business-info';
import { selectPersonalInfo } from '../features/application/reducers/personalInfo';
import { BUSINESS_INFO_ONE, BUSINESS_INFO_TWO, PERSONAL_INFO, PREVIEW_CARD, SPEND_INTENT } from '../paths';
import { RootState } from '../store';

export const businessInfoOneValidationSchema = yup.object(fleetSchema).pick(businessPageOneKeys);

export const businessInfoTwoValidationSchema = yup.object(fleetSchema).pick(businessPageTwoKeys);
export const businessInfoVerifyValidationSchema = yup.object(fleetSchema).pick(businessPageVerifyKeys);

export const spendIntentValidationSchemaV1 = yup.object(fleetSchema).pick(spendIntentKeys);
export const spendIntentValidationSchemaV2 = yup.object(fleetSchema).pick(spendIntentKeysV2);
export const spendIntentValidationSchema = yup.lazy((value) =>
  spendIntentValidationSchemaV1.isValidSync(value) ? spendIntentValidationSchemaV1 : spendIntentValidationSchemaV2,
);

export const personalInfoSmallBusinessValidationSchema = yup.object(personalInfoSchema);

export const personalInfoLargeBusinessInfoValidationSchema = personalInfoSmallBusinessValidationSchema.omit([
  'beneficialOwner',
  'controlPerson',
  'dob',
  'address',
  'ssnLast4',
]);

type PreviewCardPagePayload = Pick<FleetBase, 'dbaName' | 'address' | 'numCardsToOrder' | 'cardRestriction'>;
const previewCardPageKeys: Array<keyof PreviewCardPagePayload> = [
  'dbaName',
  'address',
  'numCardsToOrder',
  'cardRestriction',
];
export const previewCardValidationSchema = yup.object(fleetSchema).pick(previewCardPageKeys);

const businessInfo = (state: RootState) => selectBusinessInfo(state).businessInfo;

export const pageValidationSchema: Array<{
  route: string;
  validate: (state: RootState) => boolean;
}> = [
  {
    route: BUSINESS_INFO_ONE,
    validate: (state) =>
      state.portal.portalType == 'apply' ? businessInfoOneValidationSchema.isValidSync(businessInfo(state)) : false,
  },
  {
    route: BUSINESS_INFO_TWO,
    validate: (state) => businessInfoTwoValidationSchema.isValidSync(businessInfo(state)),
  },
  {
    route: SPEND_INTENT,
    validate: (state) => spendIntentValidationSchema.isValidSync(businessInfo(state)),
  },
  {
    route: PERSONAL_INFO,
    validate: (state) =>
      isSmallBusiness(businessInfo(state))
        ? personalInfoSmallBusinessValidationSchema.isValidSync(selectPersonalInfo(state))
        : personalInfoLargeBusinessInfoValidationSchema.isValidSync(selectPersonalInfo(state)),
  },
  {
    route: PREVIEW_CARD,
    validate: (state) => previewCardValidationSchema.isValidSync(businessInfo(state)),
  },
];
